<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const emit = defineEmits(['scratch', 'example', 'paste']);

const { t } = useI18n();

const OPTIONS = [
  {
    id: 'scratch',
    icon: 'i-lucide-mouse-pointer-click',
    event: 'scratch',
  },
  { id: 'example', icon: 'i-lucide-sparkles', event: 'example' },
  { id: 'paste', icon: 'i-lucide-clipboard-paste', event: 'paste' },
];

const onPick = option => {
  if (option.event === 'scratch') emit('scratch');
  else if (option.event === 'example') emit('example');
  else emit('paste');
};
</script>

<template>
  <div
    class="flex flex-col gap-3 p-4 border shadow-lg pointer-events-auto w-96 rounded-2xl border-n-weak bg-n-solid-1"
  >
    <div class="flex flex-col gap-1">
      <h2 class="text-base font-semibold text-n-slate-12">
        {{ t('AGENT_BOTS.VISUAL_BUILDER.ONBOARDING.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ t('AGENT_BOTS.VISUAL_BUILDER.ONBOARDING.DESCRIPTION') }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      <button
        v-for="option in OPTIONS"
        :key="option.id"
        type="button"
        class="flex items-center gap-3 px-3 py-2.5 border rounded-xl text-start border-n-weak hover:border-n-brand hover:bg-n-alpha-1"
        @click="onPick(option)"
      >
        <span
          class="flex items-center justify-center rounded-lg size-8 shrink-0 bg-n-alpha-2 text-n-slate-11"
        >
          <Icon :icon="option.icon" class="size-4" />
        </span>
        <span class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-n-slate-12">
            {{
              t(
                `AGENT_BOTS.VISUAL_BUILDER.ONBOARDING.${option.id.toUpperCase()}`
              )
            }}
          </span>
          <span class="text-xs text-n-slate-11">
            {{
              t(
                `AGENT_BOTS.VISUAL_BUILDER.ONBOARDING.${option.id.toUpperCase()}_DESC`
              )
            }}
          </span>
        </span>
      </button>
    </div>
  </div>
</template>
